import {
  Box,
  Button,
  Card,
  Chip,
  Collapse,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Layout from 'src/components/layout/Layout';
import { api } from 'src/api/endpoints';
import AsyncSelect from 'react-select/async';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getUsersScreens } from 'src/redux/actions/ScreenManagementAd';
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import StayCurrentLandscapeIcon from '@mui/icons-material/StayCurrentLandscape';
import { NetworkIcon } from '../../icons/untitled-ui/duocolor/network';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { tooltipClasses } from '@mui/material/Tooltip';
import BlockIcon from '@mui/icons-material/Block';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MenuIcon from '@mui/icons-material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SlideshowIcon from '@mui/icons-material/Slideshow';

import './selectStyles.css';
import UsersSchedulerEventsList from './EventsList';
import PlaylistContentList from './PlaylistContentList';
import RedesignPlayer from '../screen/components/RedesignPlayer';
import ScreenDetailsDialog from './ScreenDetails';

const ScreensTableHeading = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <TableRow hover>
      <TableCell align='left'>Screen Name</TableCell>
      <TableCell align='center'>Status</TableCell>
      <TableCell align='center'>Link</TableCell>
      <TableCell align='center'>Pairing Code</TableCell>
      <TableCell align='center'>Orientation</TableCell>
      <TableCell align='center'>User</TableCell>
      <TableCell align='center'>Preview</TableCell>
      {/* <TableCell align='center'>Preview</TableCell> */}
      <TableCell align='center'>Scheduler</TableCell>
      <TableCell align='center'>Playlist Name</TableCell>
      <TableCell align='center'>Location</TableCell>
      <TableCell align='center'>APK</TableCell>
      <TableCell align='center'>Offline Mode</TableCell>
      <TableCell align='center'>Details</TableCell>
    </TableRow>
  );
};

const ScreenRow = ({
  screen,
  setSchedulerEventsListPreview,
  setPlaylistItemsPreview,
  apkVersions,
  setPlaylistPlayerPreview,
  setScreenDetailsDialog
}) => {
  const isDarkTheme = useTheme().palette.mode === 'dark';
  const [openUserMoreInfo, setOpenUserMoreInfo] = useState(false);
  const navigate = useNavigate();
  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));
  const { t } = useTranslation();

  const isApkOutdated = (apkVersion) => {
    if (apkVersion && apkVersions?.length > 0) {
      let noDotsApkVersion = apkVersion.split('.').join('');
      let apkVersionsToCheck = apkVersions;

      if (`${apkVersionsToCheck[0].verStr}`.length > noDotsApkVersion.length) {
        const zeroos = [];
        for (
          let x = 0;
          x <
          `${apkVersionsToCheck[0].verStr}`.length - noDotsApkVersion.length;
          x++
        ) {
          zeroos.push('0');
        }
        noDotsApkVersion = Number(`${noDotsApkVersion}${zeroos.join('')}`);
      } else if (
        `${apkVersionsToCheck[0].verStr}`.length < noDotsApkVersion.length
      ) {
        const zeros = [];
        for (
          let x = 0;
          x <
          noDotsApkVersion.length - `${apkVersionsToCheck[0].verStr}`.length;
          x++
        ) {
          zeros.push('0');
        }
        apkVersionsToCheck.map((v) => {
          return {
            ...v,
            verStr: Number(`${v.verStr}${zeros.join('')}`),
          };
        });
      }
      const isApkOutdatedRes = apkVersionsToCheck?.find(
        (v) => noDotsApkVersion < v.verStr
      );
      if (isApkOutdatedRes) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <>
      <TableRow
        key={screen._id}
        sx={{
          position: 'relative',
        }}
      >
        <TableCell align='left'>
          {screen?.deviceName.length > 30
            ? `${screen?.deviceName.slice(0, 30)}...`
            : screen?.deviceName}
        </TableCell>
        <TableCell align='center'>
          {screen?.isOnline ? (
            screen?.isInOfflineMode ? (
              <Chip color='warning' label='OFF-LINE MODE' />
            ) : (
              <Chip color='success' label='ON-LINE' />
            )
          ) : (
            <Chip color='error' label='OFF-LINE' />
          )}
        </TableCell>
        <TableCell align='center'>
          {/* {screen?.locationDetails ? (
            screen?.locationDetails.fullLocation ? (
                !screen?.isOnline ? (
                'N/A'
                ) : (
                <NetworkIcon
                    ethernetStatus={screen?.device_details?.ethernetStatus}
                    wifiSignal={screen?.device_details?.wifiSignal}
                    connectionType={screen?.device_details?.connectionType}
                />
                )
            ) : (
                <HtmlTooltip
                title={
                    <>
                    {t('components.tableBodies.notAccurateLocation')} &nbsp;
                    <span
                        role='button'
                        style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => navigate(`/screendetail/${screen?._id}`)}
                    >
                        set
                    </span>
                    </>
                }
                >
                <BlockIcon />
                </HtmlTooltip>
            )
            ) : (
            <HtmlTooltip
                title={
                <>
                    {t('components.tableBodies.locationNecessary')} &nbsp;
                    <span
                    role='button'
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => navigate(`/screendetail/${screen?._id}`)}
                    >
                    set
                    </span>
                </>
                }
            >
                <BlockIcon />
            </HtmlTooltip>
            )} */}
          {!screen?.isOnline ? (
            <BlockIcon />
          ) : (
            <NetworkIcon
              ethernetStatus={screen?.device_details?.ethernetStatus}
              wifiSignal={screen?.device_details?.wifiSignal}
              connectionType={screen?.device_details?.connectionType}
            />
          )}
        </TableCell>
        <TableCell align='center'>{screen?.screenCode}</TableCell>
        <TableCell align='center'>
          {+screen?.device_details?.width > +screen?.device_details?.height ? (
            <StayCurrentLandscapeIcon
              sx={{ display: 'block', margin: '0 auto' }}
            />
          ) : (
            <StayCurrentPortraitIcon
              sx={{ display: 'block', margin: '0 auto' }}
            />
          )}
          {screen?.device_details?.width +
            ' x ' +
            screen?.device_details?.height}
        </TableCell>
        <TableCell align='right'>
          {screen?.userDetails?.fullname || 'N/A'}
          <IconButton onClick={() => setOpenUserMoreInfo(!openUserMoreInfo)}>
            {openUserMoreInfo ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell align='center'>
          <IconButton onClick={() => setPlaylistPlayerPreview({open: true, playlist: screen?.playlistDetails})}>
            <SlideshowIcon color="primary" />
          </IconButton>
        </TableCell>
        {/* <TableCell textAlign='center'>Preview</TableCell> */}
        <TableCell align={screen?.schedulerDetails?.name ? 'right' : "center"}>
          {screen?.schedulerDetails?.name ? (
            <>
              <Chip
                label={
                  screen?.schedulerDetails?.name.length > 20
                    ? `${screen?.schedulerDetails?.name.slice(0, 20)}...`
                    : screen?.schedulerDetails?.name
                }
              />
              <IconButton
                onClick={() =>
                  setSchedulerEventsListPreview({
                    open: true,
                    schedulerId: screen?.schedulerDetails,
                  })
                }
              >
                <MenuIcon />
              </IconButton>
            </>
          ) : (
            <BlockIcon />
          )}
        </TableCell>
        <TableCell align='right'>
          {screen?.playlistDetails?.playlistName.length > 30
            ? `${screen?.playlistDetails?.playlistName.slice(0, 30)}...`
            : screen?.playlistDetails?.playlistName || 'N/A'}
          <IconButton
            onClick={() =>
              setPlaylistItemsPreview({
                open: true,
                playlistItems: screen?.playlistDetails,
              })
            }
          >
            <MenuIcon />
          </IconButton>
        </TableCell>
        <TableCell align='center'>
          <Tooltip title={screen?.locationDetails?.formatted_address}>
            {screen?.locationDetails?.short_address?.replace(
              'United States',
              'US'
            ).replace(" ", ', ')}
          </Tooltip>
        </TableCell>
        <TableCell align='center'>
          <Typography
            color={
              isApkOutdated(screen?.device_details?.software)
                ? 'warning.main'
                : 'success.main'
            }
          >
            {screen?.device_details?.software}
          </Typography>
        </TableCell>
        <TableCell align='center'>
          <Switch disabled defaultChecked={screen?.offline_mode_enabled} />
        </TableCell>
        <TableCell align='center'>
            <IconButton onClick={() => {
              setScreenDetailsDialog({open: true, screen: screen})
              // navigate(`/screendetail/${screen?._id}`)
            }}>
                <MoreVertIcon/>
            </IconButton>
        </TableCell>
        <Collapse
          in={openUserMoreInfo}
          sx={{
            margin: '0 auto',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <Paper />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              padding: '10px 50px',
              backgroundColor: `${isDarkTheme ? '#1C2536' : '#ffffffff'}`,
              minHeight: '75px',
            }}
          >
            <Paper />
            <Typography>{screen?.userDetails.email}</Typography>
            <Chip color='primary' label={screen?.userDetails.role} />
            <Button
              color={
                screen?.userDetails.plan?.name == 'Free'
                  ? 'success'
                  : screen?.userDetails.plan?.name == 'Basic'
                  ? 'primary'
                  : screen?.userDetails.plan?.name == 'Premium'
                  ? 'secondary'
                  : 'info'
              }
              onClick={() =>
                navigate(`/user-subscription/${screen?.userDetails?._id}`)
              }
            >
              {screen?.userDetails.plan?.name}
            </Button>
            <Typography>
              Last Login:{' '}
              {new Date(screen?.userDetails?.lastLogin).toLocaleDateString()}
            </Typography>
          </Box>
        </Collapse>
      </TableRow>
    </>
  );
};

const loadOptions = async (inputValue, callback) => {
  console.log(inputValue);
  try {
    const resp = await api.get('/screensManagerAD/searchUserEmail', {
      params: { query: inputValue },
    });
    const options = resp.data.data.map((email) => ({
      label: email.email,
      value: email.email,
    }));
    console.log(options);
    callback(options);
  } catch (err) {
    console.log(err);
    callback([]);
  }
};

const UserScreensAD = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { screens, totalScreens, page, limit, pages } = useSelector(
    (state) => state.ScreenManagement
  );

  const [playlistPlayerPreview, setPlaylistPlayerPreview] = useState({
    playlist: null,
    open: false
  })

  const [screenDetailsDialog, setScreenDetailsDialog] = useState({
    open: false,
    screen: null
  })

  const { apkVersions } = useSelector((state) => state.Apk);

  console.log(screens);

  const dispatch = useDispatch();

  const [schedulerEventsListPreview, setSchedulerEventsListPreview] = useState({
    schedulerId: null,
    open: false,
  });

  const [playlistItemsPreview, setPlaylistItemsPreview] = useState({
    playlistItems: null,
    open: false,
  });

  const [screenFilters, setScreenFilters] = React.useState({
    pairingCode: '',
    userEmail: '',
    userId: '',
    page: 1,
    limit: 10,
    status: 'all',
    name: '',
    immediatelyUpdate: false,
  });

  useEffect(() => {
    if (screenFilters.immediatelyUpdate) {
      dispatch(
        getUsersScreens({
          page: screenFilters.page,
          limit: screenFilters.limit,
          email: screenFilters.userEmail,
          userId: screenFilters.userId,
          pairingCode: screenFilters.pairingCode,
          status: screenFilters.status == 'all' ? '' : screenFilters.status,
        })
      );
      setScreenFilters({ ...screenFilters, immediatelyUpdate: false });
    }
  }, [screenFilters]);

  return (
    <Layout title={t('views.scheduler.title')}>
      <Grid
        container
        spacing={3}
        sx={{
          p: 2,
          height: screenDetailsDialog.open ? '150vh' : '',
          display: "block"
        }}
      >
        <Grid item xs={12}>
          <Card
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '20px',
              gap: '10px',
              flexWrap: 'wrap',
              overflow: 'visible',
            }}
          >
            <TextField
              label={'Pairing Code'}
              variant='outlined'
              autoComplete='off'
              size='small'
              value={screenFilters.pairingCode}
              onChange={(e) =>
                setScreenFilters({
                  ...screenFilters,
                  pairingCode: e.target.value,
                })
              }
            />
            <AsyncSelect
              className='react-select-container'
              classNamePrefix='react-select'
              cacheOptions
              placeholder="User email"
              loadOptions={loadOptions}
              defaultOptions
              onChange={(selectedOption) => {
                setScreenFilters({
                  ...screenFilters,
                  userEmail: selectedOption ? selectedOption.value : '',
                });
              }}
            />
            <TextField
              label={'User ID'}
              size='small'
              variant='outlined'
              value={screenFilters.userId}
              onChange={(e) =>
                setScreenFilters({
                  ...screenFilters,
                  userId: e.target.value,
                })
              }
            />
            <FormControl>
              <InputLabel id='statusSelectLabel'>Status</InputLabel>
              <Select
                size='small'
                sx={{
                  minWidth: '150px',
                }}
                label='Screen status'
                labelId='statusSelectLabel'
                value={screenFilters.status}
                onChange={(e) =>
                  setScreenFilters({
                    ...screenFilters,
                    status: e.target.value,
                  })
                }
              >
                <MenuItem value='all'>All Statuses</MenuItem>
                <MenuItem value='online'>Online</MenuItem>
                <MenuItem value='offline'>Offline</MenuItem>
                <MenuItem value='offline_mode'>Offline Mode</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant='contained'
              color='primary'
              onClick={() =>
                setScreenFilters({ ...screenFilters, immediatelyUpdate: true })
              }
            >
              Apply Filters
            </Button>
            <Button variant="outlined"
              color='primary'
              onClick={() => {
                setScreenFilters({
                  pairingCode: '',
                  userEmail: '',
                  userId: '',
                  page: 1,
                  limit: 10,
                  status: 'all',
                  name: '',
                  immediatelyUpdate: true,                  
                })
              }}
            >
              Reset Filters
            </Button>
          </Card>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '20px',
              mt: 3,
            }}
          >
            <FormControl>
              <InputLabel id='limitSelectLabel'>Show on page</InputLabel>
              <Select
                labelId='limitSelectLabel'
                size='small'
                sx={{
                  minWidth: '100px',
                }}
                label='Show on page'
                value={screenFilters.limit}
                onChange={(e) =>
                  setScreenFilters({
                    ...screenFilters,
                    limit: e.target.value,
                    immediatelyUpdate: true,
                  })
                }
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <IconButton
                disabled={page == 1}
                onClick={() =>
                  setScreenFilters({
                    ...screenFilters,
                    page: screenFilters.page - 1,
                    immediatelyUpdate: true,
                  })
                }
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
              <Typography>
                {page} / {pages}
              </Typography>
              <IconButton
                disabled={page == pages}
                onClick={() =>
                  setScreenFilters({
                    ...screenFilters,
                    page: screenFilters.page + 1,
                    immediatelyUpdate: true,
                  })
                }
              >
                <KeyboardArrowRightIcon />
              </IconButton>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <Table>
              <TableHead>
                <ScreensTableHeading />
              </TableHead>
              <TableBody>
                {screens?.map((scr) => {
                  return (
                    <ScreenRow
                      apkVersions={apkVersions}
                      key={scr._id}
                      screen={scr}
                      setSchedulerEventsListPreview={
                        setSchedulerEventsListPreview
                      }
                      setPlaylistItemsPreview={setPlaylistItemsPreview}
                      setPlaylistPlayerPreview={setPlaylistPlayerPreview}
                      setScreenDetailsDialog={setScreenDetailsDialog}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </Card>
        </Grid>
      </Grid>
      <UsersSchedulerEventsList
        open={schedulerEventsListPreview.open}
        onClose={() =>
          setSchedulerEventsListPreview({ open: false, schedulerId: null })
        }
        schedulerId={schedulerEventsListPreview.schedulerId}
      />
      <PlaylistContentList
        open={playlistItemsPreview.open}
        onClose={() =>
          setPlaylistItemsPreview({ open: false, playlistItems: null })
        }
        playlistContent={playlistItemsPreview.playlistItems}
      />
      <RedesignPlayer playlist={playlistPlayerPreview.playlist} open={playlistPlayerPreview.open} onClose={() => setPlaylistPlayerPreview({open: false, playlist: null})}/>
      <ScreenDetailsDialog open={screenDetailsDialog.open} screen={screenDetailsDialog.screen} onClose={() => setScreenDetailsDialog({open: false, screen: null})} />
    </Layout>
  );
};

export default UserScreensAD;
